import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDvbgu2cTlGmXVN3fNpIYCxdHGz--wjU2M",
  authDomain: "grafton-50662.firebaseapp.com",
  projectId: "grafton-50662",
  storageBucket: "grafton-50662.firebasestorage.app",
  messagingSenderId: "989692329387",
  appId: "1:989692329387:web:f4378d1765c865561526ee",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
